import Title from './StyledTitle'

export default Title.extend`
  font-size: 14px;
  line-height: 30px;
  margin: 0;
`
